import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loading from "./Loading";
import { isAdminRole } from "../redux/action/users";

// Wraps a page only admins may open. Signed out goes to the login page; a
// profile still loading shows the spinner (the role comes from it); any other
// role goes to the dashboard. The page itself is not rendered until the check
// passes, so it never loads its data for someone who cannot see it.
//
// This hides the page in the browser only. The API must still refuse these
// calls for non-admins - the server is what actually protects the data.
function AdminOnly({ children }) {
  const login = useSelector((state) => state.login);

  if (Object.keys(login ?? {}).length === 0) return <Navigate to="/" replace />;
  if (login.profile === undefined) return <Loading />;
  if (!isAdminRole(login.profile?.roleName)) return <Navigate to="/dashboard" replace />;

  return children;
}

export default AdminOnly;
